<template>
    <div class="content-wrap">

        <!--可视区域-->
        <div class="visual-area">
            <div class="preview-area">
                <div class="status-bar">
                    <div class="">
                        10:12
                    </div>
                    <div class="status-bar-icon">
                        <img src="https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/icon/status-bar/wif.svg"/>
                        <img src="https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/icon/status-bar/Battery.svg"/>
                    </div>
                </div>
                <div class="nav-bar">
                    <span>首页</span>
                </div>
                
                <!--banner预览-->
                <div class="banner-wrap">
                    <t-swiper 
                        class="banner-swiper"
                        :duration="500"
                        :interval="5000"
                        :navigation="{ size: 'small' }"
                    >
                        <t-swiper-item
                            class="banner-swiper-item"
                            v-for="(item, index) in bannerPreview"
                            :key="index"
                        >
                            <div
                                v-if="item.image"
                                class="banner-image-wrap"
                            >
                                <!--banner预览图片-->   
                                <img 
                                    class="banner-image"
                                    :src="item.image.url"  
                                />
                            </div>

                            <div v-else class="banner-placeholder">
                                未上传Banner图片
                            </div>
                        </t-swiper-item>
                    </t-swiper>
                </div>

                 <!--快捷入口预览--> 
                <div class="quick-wrap">
                    <div 
                        class="quick-item" 
                        v-for="(item,index) in quickPreview"
                        :key="index"
                    >
                        <img class="quick-image" :src="item.img"/>
                        <span class="quick-name">{{ item.name }}</span>
                    </div>
                </div>
                
                <div class="promotion-area">
                    <div class="left-spot">
                    
                    </div>

                    <div class="right-spot">
                    
                    </div>
                </div>
                
                <div class="reclist-wrap">
                    <t-tabs
                        class="list-tab"
                        :defaultValue="defaultTabValue"
                        size="large"
                    >
                        <t-tab-panel 
                            v-for="tab in tabData"
                            :key="tab.value" 
                            :value="tab.value" 
                            :label="tab.label"
                        >
                            <template #panel>
                                <div class="list-area">
                                    <div class="list-item"
                                        v-for="item in tab.listItem"
                                        :key="item.campId"
                                    >
                                        <img class="list-image" :src="item.image">
                                        <div class="list-info">
                                            <div class="camp-name">
                                                {{ item.campName }}
                                            </div>

                                        <!--推荐标签-->   
                                        <div class="list-tag">
                                            <div 
                                                class="tag"
                                                v-for="tag in item.tags" 
                                                :key="tag" 
                                            >
                                                {{ tag }}
                                            </div>
                                        </div>
                                        <!--评分-->   
                                        <div class="rate-info">
                                            <img class="rate-image" :src="rateImage"/>
                                            <div class="rate">
                                                {{ item.rate }}
                                            </div>
                                        </div>

                                        <!--价格-->   
                                        <div class="price-info">
                                            <div class="price-wrap">
                                                <span class="price-symbol">￥</span>
                                                <span class="price">{{ item.price }}</span>
                                                <span class="price-upward">起</span>
                                            </div>
                                        </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </template>
                        </t-tab-panel>
                    </t-tabs>
                </div>

            </div>  
        </div>

        <!--设置区域-->
        <div class="set-area">
            <t-tabs
                class="list-tab"
                size="large"
                :default-value="1"
            >
                <!--Banner设置区域-->
                <t-tab-panel :value="1" label="Banner">
                    <draggable 
                        v-model="bannerItem" 
                        :item-key="(item, index) => index"
                        @start="drag=true" 
                        @end="drag=false"
                        handle=".drag-icon"
                         ghost-class="ghost-class"
                    >
                        <template #item="{ element, index }">
                            <div class="set-item-wrap" >
                                <!--Banner标题栏-->
                                <div class="set-item-bar">
                                    <div class="item-name">
                                        图片{{ index + 1 }}
                                    </div>

                                    <div class="action-area">
                                        <div class="drag-icon">
                                            <t-icon class="icon" name="move" />
                                        </div>

                                        <div class="remove-icon" @click="removeBanner(index)">
                                            <t-icon class="icon" name="delete" />
                                        </div>
                                    </div>
                                </div>

                                <!--设置Banner-->
                                <div class="set-banner">
                                    <!--设置Banner图片-->
                                    <t-upload
                                        v-model="element.image"
                                        theme="image"
                                        accept="image/*"
                                        :showImageFileName="false"
                                        :auto-upload="false"
                                        :max="1"
                                        :size-limit="sizeLimit"
                                        @success="(res, file) => uploadSuccess(res, file, index)"
                                        @fail="uploadFail"
                                    />

                                    <!--Banner跳转-链接类型-->
                                    <div class="set-link-type">
                                        <t-select
                                             v-model="element.linkType"
                                            :options="bannerLinkTypeOption"
                                            @change="() => bannerTypeChange(index)"
                                            placeholder="请选择跳转类型"                                 
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>

                                    <!--Banner跳转-小程序页面链接（linkType为1）-->
                                    <div 
                                        v-if="element.linkType === 1"
                                        class="set-link-page"
                                       
                                    >
                                        <t-select
                                            v-model="element.linkName"
                                            :options="bannerLinkOption[1]"
                                             @change="(value) => updateBannerLink(index, value)"
                                            placeholder="请选择页面"                                 
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>

                                    <!--Banner跳转-分类页链接（linkType为2）--->
                                    <div
                                        v-if="element.linkType === 2"
                                        class="set-link-category"
                                        
                                    >
                                        <t-select
                                            v-model="element.linkName"
                                            :options="bannerLinkOption[2]"
                                            @change="(value) => updateBannerLink(index, value)"
                                            placeholder="请选择分类页"                                 
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>

                                    <!--Banner跳转-营地详情页（linkType为3）--->
                                    <div
                                        v-if="element.linkType === 3"
                                        class="set-camp-detial"
                                        
                                    >
                                        <t-input
                                            v-model="element.linkName"
                                            @input="(value) => updateBannerCampLink(index, value)"  
                                            placeholder="请输入营地ID"                             
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>

                                </div>
                            </div>
                        </template>
                    </draggable>

                    <!--增加banner按钮-->
                    <div class="button-wrap">
                        <t-button 
                            v-if="bannerItem.length < 5" 
                            @click="addBanner"
                            size="large"
                            theme="primary"
                            variant="outline"
                        >
                            添加 Banner
                        </t-button>
                    </div>
                    
                </t-tab-panel>

                <!--快捷入口区域-->
                <t-tab-panel :value="2" label="快捷入口">
                    <draggable 
                        v-model="quickEntryItem" 
                        :item-key="(item, index) => index"
                        @start="drag=true" 
                        @end="drag=false"
                        handle=".drag-icon"
                         ghost-class="ghost-class"
                    >
                        <template #item="{ element, index }">
                            <div class="set-item-wrap" >
                                <!--快捷入口标题栏-->
                                <div class="set-item-bar">
                                    <div class="item-name">
                                        快捷入口{{ index + 1 }}
                                    </div>

                                    <div class="action-area">
                                        <div class="drag-icon">
                                            <t-icon class="icon" name="move" />
                                        </div>
                                    </div>
                                </div>

                                <!--快捷入口设置-->
                                <div class="set-quick">
                                    <!--设置快捷入口图片-->
                                    <t-upload
                                        v-model="element.quickImage"
                                        theme="image"
                                        accept="image/*"
                                        :showImageFileName="false"
                                        :auto-upload="false"
                                        :max="1"
                                        :size-limit="sizeLimit"
                                        @success="(res, file) => uploadQuickEntrySuccess(res, file, index)"
                                        @fail="uploadQuickEntryFail"
                                    />

                                    <!--快捷入口名称-->
                                    <div class="set-quick-name" >
                                        <t-input
                                            v-model="element.name"
                                            placeholder="请输入名称"
                                            :maxlength="6"
                                            show-limit-number                            
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>

                                     <!--快捷入口-链接类型-->
                                    <div class="set-link-type">
                                        <t-select
                                             v-model="element.quickLinkType"
                                            :options="quickEntryLinkTypeOption"
                                            @change="quickEntryLinkTypeChange(index)"
                                            placeholder="请选择跳转类型"                                 
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                                
                                    </div>

                                    <!--快捷入口-页面链接选项-->
                                    <div 
                                        v-if="element.quickLinkType === 1"
                                        class="set-link-page"
                                    >
                                        <t-select
                                            v-model="element.quickLinkName"
                                            :options="quickEntryLinkOption[1]"
                                            @change="(value) => updateQuickEntryLink(index, value)"
                                            placeholder="请选择页面"                                 
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>

                                    <!--快捷入口-分类页链接选项-->
                                    <div
                                        v-if="element.quickLinkType === 2"
                                        class="set-link-category"
                                    >
                                        <t-select
                                            v-model="element.quickLinkName"
                                            :options="quickEntryLinkOption[2]"
                                            @change="(value) => updateQuickEntryLink(index, value)"
                                            placeholder="请选择分类页"                                 
                                            size="medium"
                                            filterable
                                            clearable
                                        />                  
                                    </div>
                                    
                                </div>
                            </div>
                        </template>
                    </draggable>
                </t-tab-panel>

                <t-tab-panel 
                    :value="3" label="运营位"
                >
                    <div class="set-item-wrap">
                        暂不支持配置
                    </div>
                </t-tab-panel>

                <t-tab-panel 
                    :value="4" label="推荐营地"
                > 
                    <div class="set-item-wrap">
                        暂不支持配置
                    </div>
                </t-tab-panel>
            </t-tabs>
        </div>


    </div> 

    <!--底部操作栏-->
    <div class="action-bar">
        <div class="last-publish-info">
            最后发布时间：{{ lastPublishTime }}	
        </div>

        <div class="action-bar-button">
            
            <t-button
                @click="publishClick"
                :loading="isPublishing"
                :disabled="isPublishing"
                size="medium" 
                theme="primary"
            >
                立即发布
            </t-button>
        </div>       
    </div>
</template>


<script setup lang="jsx">
    import { ref, onMounted, watch, computed, onUnmounted,nextTick   } from 'vue';
    import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
    import draggable from 'vuedraggable';
    import bannerAPI from '../../../api/banner-api';
    import homeAPI from '../../../api/home-api';
    import { formatTime } from '../../../utils/datetime'

    
    /**
     * 预览数据
     */
    const rateImage=ref("https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/icon/star.png")
    const tabData =ref([
        {
            value: "1",
            label:"推荐营地",
            listItem: [
                {
                    campId:"00000001",
                    image: "https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/camp/00000001.png",
                    campName: "阳光沙滩营地",
                    tags: ["海边", "宠物友好"],
                    rate: 4.5,
                    price: 299
                },

                {
                    campId:"00000002",
                    image: "https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/camp/00000001.png",
                    campName: "阳光沙滩营地",
                    tags: ["海边", "宠物友好"],
                    rate: 4.5,
                    price: 299
                },
            ]
        },
        {
            value: "2",
            label:"宠物营地",
            listItem: [
                {
                    campId:"00000002",
                    image: "https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/camp/00000001.png",
                    campName: "大地之眼营地",
                    tags: ["海边", "宠物友好"],
                    rate: 4.5,
                    price: 299
                },
                {
                    campId:"00000003",
                    image: "https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/camp/00000001.png",
                    campName: "阳光沙滩营地",
                    tags: ["海边", "宠物友好"],
                    rate: 4.5,
                    price: 299
                },
            ]
        },

    ]);

    // 预览tab默认数据
    const defaultTabValue = tabData.value[0].value

    // 设置拖拽状态
    const drag = ref(false);
    
    /**
     * Banner初始化
     */

    //Banner设置项初始化
    const bannerItem = ref([
        { image: [], linkType: null, linkName: '', linkUrl: '' }, 
        { image: [], linkType: null, linkName: '', linkUrl: ''  }  
    ]);
    //Banner链接类型初始化
    const bannerLinkTypeOption = ref([]);
    //Banner链接选项初始化
    const bannerLinkOption = ref({});
    
    /**
     * 获取Banner数据
     */
    const getBannerData = async () => {
        try {
            const response = await bannerAPI.getBannerList();
            console.log('后端返回的Banner数据:', response); 
            if (response && response.banner_data) {
                bannerItem.value = response.banner_data.map(item => ({
                    id: item.id,
                    image: [{ url: item.image }],
                    linkType: item.link_type, 
                    linkName: item.link_name ||'',
                    linkUrl: item.link_url,
            }));
            } else {
                throw new Error('Banner 数据格式无效');
            }
        } catch (error) {
            console.error('获取Banner数据失败:', error);
            MessagePlugin.error('获取Banner数据失败');
            // 如果后端无数据，使用默认值
            bannerItem.value = [
                { image: [], linkType: null, linkName: '', linkUrl: '' },
                { image: [], linkType: null, linkName: '', linkUrl: '' }
            ];
        }
    };

    /**
     * 链接类型修改，清空链接名称和URL
     */
     const bannerTypeChange = (index) => {
        bannerItem.value[index].linkName = ''; 
        bannerItem.value[index].linkUrl = ''; 
    };

    /**
     * 新增Banner
     */
    const addBanner = () => {
        if (bannerItem.value.length < 5) {
            bannerItem.value.push({ image: [], linkType: null, linkName: '' });
        } else {
            MessagePlugin.warning('最多添加5个Banner');
        }
    };

    /**
     * 移除Banner
     */
    const removeBanner = (index) => {
        if (bannerItem.value.length <= 1) {
            MessagePlugin.warning('最少保留一个 Banner');
            return;
        }  
        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: `确定要删除 图片 ${index + 1} 吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            onConfirm: () => {
            bannerItem.value.splice(index, 1);
            dialog.destroy();
            },
        });
    };
    
    /**
     * 获取Banner链接选项
     */
    const getBannerLinkOption = async () => {
        try {
            const response = await bannerAPI.bannerLink();
            console.log('后端返回banner链接数据:', response);

            if (response && typeof response === 'object') {
                bannerLinkOption.value = response;
                
                // 从后端返回的数据创建 bannerLinkTypeOption
                bannerLinkTypeOption.value = Object.keys(response).map(key => ({
                    label: getLinkTypeLabel(parseInt(key)),
                    value: parseInt(key)
                }));
            } else {
                throw new Error('返回数据格式无效');
            }
        } catch (error) {
            console.error('获取Banner链接选项失败:', error);
            MessagePlugin.error('获取Banner链接选项失败');
            bannerLinkOption.value = {};
            bannerLinkTypeOption.value = [];
        }
    };

    /**
     * 更新Banner链接选项
     */
    const updateBannerLink = (index, selectedValue) => {
        const item = bannerItem.value[index];
        const selectedOption = bannerLinkOption.value[item.linkType]?.find(
            option => option.value === selectedValue
        );
        if (selectedOption) {
            item.linkName = selectedOption.label;
            item.linkUrl = selectedOption.value;
        } else {
            item.linkName = '';
            item.linkUrl = '';
        }
    };

    /**
     * 更新Banner营地链接
     */
    const updateBannerCampLink = (index, value) => {
        const item = bannerItem.value[index];
        // 检查 value 是否为 InputEvent 对象
        if (value instanceof InputEvent) {
            value = value.target.value; 
        }
        item.linkName = value;
        item.linkUrl = `/pages/detail/detail/${value}`; // 设置为小程序页面路径格式
    };

    // 辅助函数：链接类型对应标签
    const getLinkTypeLabel = (type) => {
        switch (type) {
            case 1: return '小程序页面';
            case 2: return '分类页';
            case 3: return '营地详情页';
            default: return '未知类型';
        }
    };

    
    /**
     * 图片上传处理
     */
    const sizeLimit = ref(500 * 1024);

    // 图片上传成功处理
    const uploadSuccess = (response, file, index) => {
        const imageUrl = response?.url || file.url || URL.createObjectURL(file.raw);
        bannerItem.value[index].image = [{ 
            url: imageUrl,
            name: file.name,
            status: 'success',
            raw: file.raw 
        }];
        console.log('图片上传成功:', imageUrl);
        MessagePlugin.success('图片上传成功');
    };

    // 图片上传失败处理
    const uploadFail = (response, index) => {
        console.error('图片上传失败:', response);
        MessagePlugin.error('图片上传失败，请重试');
        bannerItem.value[index].image = [];
    };


    /**
     * 快捷入口设置
    */
   
    //快捷入口初始化
    const quickEntryItem = ref([
        { id: null, name: '', quickImage: [], quickLinkType: null, quickLinkName: '', quickLinkUrl: '', order: 1 },
        { id: null, name: '', quickImage: [], quickLinkType: null, quickLinkName: '', quickLinkUrl: '', order: 2 },
        { id: null, name: '', quickImage: [], quickLinkType: null, quickLinkName: '', quickLinkUrl: '', order: 3 },
        { id: null, name: '', quickImage: [], quickLinkType: null, quickLinkName: '', quickLinkUrl: '', order: 4 },
        { id: null, name: '', quickImage: [], quickLinkType: null, quickLinkName: '', quickLinkUrl: '', order: 5 }
    ]);
    // 快捷入口选项初始化
    const quickEntryLinkTypeOption = ref([]);
    const quickEntryLinkOption = ref({});

    /**
     * 获取快捷入口数据
     */
    const getQuickEntryData = async () => {
    try {
        const response = await homeAPI.getQuickEntryList();
        console.log('后端返回快捷入口数据:', response);
        if (response && response.quick_entry_data) {
        quickEntryItem.value = response.quick_entry_data.map(item => ({
            id: item.id,
            quickImage: item.image ? [{ url: item.image }] : [],
            name: item.name,
            quickLinkType: item.link_type,
            quickLinkName: item.link_name || '',
            quickLinkUrl: item.link_url,
            
        }));
        } else {
        throw new Error('快捷入口数据格式无效');
        }
    } catch (error) {
        console.error('获取快捷入口数据失败:', error);
        MessagePlugin.error('获取快捷入口数据失败');
    }
    };


    /**
     * 获取快捷入口-链接选项
     */
    const getQuickLinkOption = async () => {
        try {
            const quickEntryResponse = await homeAPI.getQuickEntryLink();

            console.log('后端返回的快捷入口链接数据:', quickEntryResponse);

            if (quickEntryResponse && typeof quickEntryResponse === 'object') {
                quickEntryLinkOption.value = quickEntryResponse;
                
                quickEntryLinkTypeOption.value = Object.keys(quickEntryResponse).map(key => ({
                    label: getLinkTypeLabel(parseInt(key)),
                    value: parseInt(key)
                }));

                // 转换链接选项的格式
                Object.keys(quickEntryResponse).forEach(key => {
                    quickEntryLinkOption.value[key] = quickEntryResponse[key].map(item => ({
                        label: item.name,
                        value: item.link_url
                    }));
                });
            } else {
                throw new Error('快捷入口链接数据格式无效');
            }
        } catch (error) {
            console.error('获取快捷入口链接选项失败:', error);
            MessagePlugin.error('获取快捷入口链接选项失败');
            quickEntryLinkOption.value = {};
            quickEntryLinkTypeOption.value = [];
        }
    };

    /**
     * 快捷入口选项更新
     */
    const updateQuickEntryLink = (index, selectedValue) => {
        const item = quickEntryItem.value[index];
        const selectedOption = quickEntryLinkOption.value[item.quickLinkType].find(
            option => option.value === selectedValue
        );
        if (selectedOption) {
            item.quickLinkName = selectedOption.label;
            item.quickLinkUrl = selectedOption.value; 
        } else {
            item.quickLinkName = '';
            item.quickLinkUrl = '';
        }
    };

    /**
     * 快捷入口链接类型修改
     */
    const quickEntryLinkTypeChange = (index) => {
        const item = quickEntryItem.value[index];
            item.quickLinkName = '';
            item.quickLinkUrl = ''; // 清空 URL
    };

    /**
     * 快捷入口图片上传成功处理
     */
     const uploadQuickEntrySuccess = (response, file, index) => {
        const imageUrl = response?.url || file.url || URL.createObjectURL(file.raw);
        quickEntryItem.value[index].quickImage = [{ 
            url: imageUrl,
            name: file.name,
            status: 'success',
            raw: file.raw 
        }];
        console.log('快捷入口图片上传成功:', imageUrl);
        MessagePlugin.success('图片上传成功');
    };
    
    /**
     * 快捷入口图片上传失败处理
     */
    const uploadQuickEntryFail = (response, index) => {
        console.error('快捷入口图片上传失败:', response);
        MessagePlugin.error('图片上传失败，请重试');
        quickEntryItem.value[index].quickImage = [];
    };

    /**
     * 组件挂载获取数据
     */
    onMounted(() => {
        getBannerData();
        getBannerLinkOption();
        getQuickEntryData();
        getQuickLinkOption();
        getLastPublishTime();
    });

    /**
     * 释放创建的对象 URL
     */
    onUnmounted(() => {
        // 释放Banner图片 URL
        bannerItem.value.forEach(item => {
            if (item.image && item.image[0] && item.image[0].raw) {
                URL.revokeObjectURL(item.image[0].url);
            }
        });
        // 释放快捷入口图片 URL
        quickEntryItem.value.forEach(item => {
            if (item.quickImage && item.quickImage[0] && item.quickImage[0].raw) {
                URL.revokeObjectURL(item.quickImage[0].url);
            }
        });
    });


    /**---预览---*/

    /**
     * banner预览
     */
     const bannerPreview = computed(() => bannerItem.value.map(item => {
        let imageUrl = null;
        if (item.image && item.image.length > 0) {
            const image = item.image[0];
            if (image.url) {
                imageUrl = image.url;
            } 
            else if (image.raw instanceof File) {
                imageUrl = URL.createObjectURL(image.raw);
            }
        }
        return {
            image: imageUrl ? { url: imageUrl } : null,
        };
    }));

    /**
     * 快捷入口预览
     */ 
    const defaultImage = 'https://yequ-admin-1331262631.cos.ap-nanjing.myqcloud.com/general/40.png';
    const quickPreview = computed(() => {
    return quickEntryItem.value.map(item => {
            let imageUrl = '';
            if (item.quickImage && item.quickImage.length > 0) {
                const image = item.quickImage[0];
                imageUrl = image.url || (image.raw instanceof File ? URL.createObjectURL(image.raw) : '');
            }

            imageUrl = imageUrl || defaultImage;
            
            return {
                img: imageUrl,
                name: item.name || ''
            };
        });
    });

    
    watch(bannerItem, (newValue) => {
        console.log('banner更新:', JSON.stringify(newValue));
    }, { deep: true });

    watch(quickEntryItem, (newValue) => {
        console.log('快捷入口项更新:', newValue);
    }, { deep: true });


    /**---发布事件---*/
    const isPublishing = ref(false);

    /**
     * 发布
     */
    const publishClick = async () => {
    if (isPublishing.value) return;
    isPublishing.value = true;

    try {
        const formData = new FormData();

        // 处理 Banner 数据
        const bannerDataList = bannerItem.value.map((item, index) => {


            const bannerData = {
                id: item.id || undefined,
                link_type: item.linkType,
                order: index + 1
            };

            // 根据链接类型处理link_name和link_url
            if (item.linkType === 3) {
                // 营地详情页：link_name为"营地详情+ID"，link_url为小程序页面路径
                bannerData.link_name = `营地详情${item.linkName}`;
                bannerData.link_url = `/pages/detail/detail/${item.linkName}`;
            } else {
                // 其他类型：使用原始值
                bannerData.link_name = item.linkName;
                bannerData.link_url = item.linkUrl;
            }

            if (item.image && item.image.length > 0) {
                if (item.image[0].raw instanceof File) {
                    formData.append(`image_${index}`, item.image[0].raw, item.image[0].name);
                    bannerData.new_image = true;
                } else if (item.image[0].url) {
                    bannerData.image = item.image[0].url;
                }
            }

            return bannerData;
        });

        // 处理 Quick Entry 数据
        const quickEntryDataList = quickEntryItem.value.map((item, index) => {
            const quickEntryData = {
                id: item.id || undefined,
                name: item.name || '',
                link_type: item.quickLinkType,
                link_name: item.quickLinkName || '',
                link_url: item.quickLinkUrl ||'',
                order: index + 1
            };

            if (item.quickImage && item.quickImage.length > 0) {
                if (item.quickImage[0].raw instanceof File) {
                    formData.append(`image_${index}`, item.quickImage[0].raw, item.quickImage[0].name); // 与后端一致
                    quickEntryData.new_image = true;
                } else if (item.quickImage[0].url) {
                    quickEntryData.image = item.quickImage[0].url;
                }
            }

            return quickEntryData;
        });

        formData.append('banner_list', JSON.stringify(bannerDataList));
        formData.append('quick_entry_list', JSON.stringify(quickEntryDataList));

        console.log('发送 Banner 数据:', JSON.stringify(bannerDataList, null, 2));
        console.log('发送 Quick Entry 数据:', JSON.stringify(quickEntryDataList, null, 2));

        const [bannerResponse, quickResponse] = await Promise.all([
            bannerAPI.batchUpdateBanner(formData),
            homeAPI.batchUpdateQuickEntry(formData)
        ]);

        if (bannerResponse.success && quickResponse.success) {
            MessagePlugin.success('Banner 和快捷入口发布成功');
            lastPublishTime.value = formatTime(new Date());
            await Promise.all([getBannerData(), getQuickEntryData()]);
        } else {
            throw new Error(bannerResponse.message || quickResponse.message || '发布失败');
        }
    } catch (error) {
        console.error('发布失败:', error);
        MessagePlugin.error(`发布失败: ${error.message}`);
    } finally {
        isPublishing.value = false;
    }
};
    const lastPublishTime = ref('--');
    const getLastPublishTime = async () => {
    try {
        const response = await homeAPI.getHomeUpdateTime();
        if (response && response.last_update_time) {
            lastPublishTime.value = formatTime(new Date(response.last_update_time));
        } else {
            lastPublishTime.value = '--';
        }
    } catch (error) {
        console.error('获取最后更新时间失败:', error);
        lastPublishTime.value = '--';
    }
};
</script>

<style scoped>
    @import "./home-admin.css";
    @import "../../../components/style/style-content.css";   
</style>